<div class="modal-header">
  <h4 class="modal-title">{{titleString | translate}}</h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner p-0">
    <div class="modal-body-inner">
      <form class="w-100" novalidate [formGroup]="form">
        <div class="pt-1 col-12 mb-3 row">
          <label class="col-md-4 col-form-label">{{'copyPropertiesModal.source_article' | translate}}</label>
          <div class="col-md-8">
            <input type="text"
                   (keydown.enter)="save()"
                   [class.is-invalid]="form.controls?.source?.touched && form.controls?.source?.invalid"
                   class="form-control"
                   formControlName="source"
                   name="source">
          </div>
          <div *ngIf="form.controls?.source?.touched && form.controls?.source?.invalid" class="ps-3 invalid-feedback d-flex">{{getInputError(form.get('source'))}}</div>
        </div>
      </form>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary btn-cancel" (click)="close()">
    {{'global.label.close' | translate}}
  </button>
  <button class="btn btn-primary btn-forward" [disabled]="form.controls.source.invalid" (click)="save()">
    {{'global.label.step_forward' | translate}}
  </button>
</div>
